import { useEffect, useState } from 'react';
import { useAuthContext } from '../auth/context/useAuthContext';

/**
 * Hook that interfaces with the Auth Context to provide the currently logged in users groups
 */
export function useCurrentUserGroups() {
  const authContext = useAuthContext();
  const [userGroups, setUserGroups] = useState(authContext.userGroups);
  const isLoading = authContext.loadingGroups;
  useEffect(() => {
    setUserGroups(authContext.userGroups);
  }, [authContext.userGroups]);
  return {
    userGroups,
    isLoading
  };
}